export default {"src":"/_next/static/media/icon_back.3bf9b05e.svg","height":60,"width":60,"blurWidth":0,"blurHeight":0};